import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';

import Picture from '../../components/Picture'
import CheckList from '../../components/site/CheckList/CheckList'
import CheckListItem from '../../components/site/CheckList/CheckListItem'
import DemoForm from '../../components/site/Forms/DemoForm'

const SECTIONS = {
    vendasOrganizadas: {
        title: 'Vendas organizadas, ágeis e sem retrabalho',
        checklist: [
            <Fragment><b>Todas as vendas num só lugar</b>: pare de receber pedidos por whatsapp, e-mail ou anotações no bloco e na planilha</Fragment>,
            <Fragment><b>Mais tempo para o seu time</b>: chega de ficar digitando pedidos no fim do dia</Fragment>,
            <Fragment><b>Economia de 8 horas por semana</b></Fragment>,
            <Fragment><b>Padronize o visual de todos os pedidos</b>, configurando de acordo com a sua necessidade</Fragment>,
            <Fragment><b>Envie o pedido em PDF</b> por e-mail com apenas 1 clique</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png',
        }
    },
    gestaoPedidos: {
        title: 'Gestão de pedidos organizada, ágil e sem retrabalho',
        checklist: [
            <Fragment><b>Todas as vendas num só lugar</b>: pare de receber pedidos por whatsapp, e-mail ou anotações no bloco e na planilha</Fragment>,
            <Fragment><b>Economia de 8 horas por semana</b></Fragment>,
            <Fragment><b>Padronize o visual de todos os pedidos</b>, configurando de acordo com a sua necessidade</Fragment>,
            <Fragment><b>Envie o pedido em PDF</b> por e-mail com apenas 1 clique</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png',
        }
    },
    representanteOrganizado: {
        title: 'Representante organizado, ágil e que não precisa ter retrabalho',
        checklist: [
            <Fragment><b>Todas as vendas num só lugar</b>: pare de receber pedidos por whatsapp, e-mail ou anotações no bloco e na planilha</Fragment>,
            <Fragment><b>Mais tempo</b>: sem necessidade de um profissional exclusivo para digitação de pedidos ou fazer o representante digitar pedidos no fim do dia</Fragment>,
            <Fragment><b>Economia de 8 horas por semana</b></Fragment>,
            <Fragment><b>Padronize o visual de todos os pedidos</b>, configurando de acordo com a sua necessidade</Fragment>,
            <Fragment><b>Envie o pedido em PDF</b> por e-mail com apenas 1 clique</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/forca-vendas/vendas-organizadas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png',
        }
    },
    mobilidade: {
        title: 'Mobilidade para os representantes',
        checklist: [
            <Fragment><b>Funciona offline</b> e fecha vendas mesmo sem internet.</Fragment>,
            <Fragment>Funciona no tablet, celular e no notebook.</Fragment>,
            <Fragment>O Aplicativo para representantes mais fácil de usar do mercado.</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/mobilidade-representantes.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/mobilidade-representantes-mobile.png',
        }
    },
    entradaPedidos: {
        title: 'Entrada de pedidos organizada, ágil e sem retrabalho',
        checklist: [
            <Fragment><b>Pedidos num só lugar</b>: pare de receber pedidos por whatsapp, e-mail ou anotações no bloco e na planilha</Fragment>,
            <Fragment><b>Economia de 8 horas por semana</b>: chega de redigitar pedidos no fim do dia.</Fragment>,
            <Fragment><b>Padronize o visual de todos os pedidos</b>, configurando de acordo com a sua necessidade</Fragment>,
            <Fragment><b>Envie o pedido em PDF</b> por e-mail com apenas 1 clique</Fragment>,

        ],
        img: {
            url: '/images/site/landing-pages/entrada-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/entrada-pedidos-mobile.png',
        }
    },
    semErrosParceiros: {
        title: <Fragment>Sem erros,<br />mais resultados</Fragment>,
        checklist: [
            <Fragment>Integrado ao seu ERP o pedido é enviado direto ao faturamento</Fragment>,
            <Fragment>Garanta que os representantes apliquem descontos e políticas comerciais corretamente</Fragment>,
            <Fragment>Configure múltiplas tabelas de preço por vendedor, cliente ou outro critério a sua escolha</Fragment>,
            <Fragment>Controle o estoque e mostre para os representantes a quantidade de itens disponível</Fragment>,
            <Fragment>Calcule automaticamente vendas com impostos como ICMS, ST e IPI</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png',
        }
    },
    semErros: {
        title: <Fragment>Sem erros,<br />mais resultados</Fragment>,
        checklist: [
            <Fragment><b>Integrado ao seu ERP</b>: além de poder integrar com qualquer ERP, o Mercos conta com mais de 200 ERPs parceiros</Fragment>,
            <Fragment>Garanta que os representantes apliquem <b>descontos e políticas comerciais</b> corretamente</Fragment>,
            <Fragment>Configure <b>múltiplas tabelas de preço por vendedor</b>, cliente ou outro critério a sua escolha</Fragment>,
            <Fragment><b>Controle o estoque</b> e mostre para os representantes a quantidade de itens disponível</Fragment>,
            <Fragment><b>Calcule automaticamente</b> pedidos com impostos como ICMS, ST e IPI</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/sem-erros.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/sem-erros-mobile.png',
        }
    },
    imagemProfissional: {
        title: 'Imagem profissional no cliente',
        checklist: [
            <Fragment>Apresente um <b>catálogo digital com fotos</b></Fragment>,
            <Fragment>Atenda seus clientes de forma organizada desde a apresentação até o fechamento do pedido</Fragment>,
            <Fragment>Tenha o <b>histórico de compra de cada cliente</b> e guie os próximos passos da negociação</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/imagem-profissional.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/imagem-profissional-mobile.png',
        }
    },
    potencialize: {
        title: 'Potencialize suas vendas',
        checklist: [
            <Fragment>O aplicativo faz <b>sugestões de venda</b> para o representante: produtos para reposição, lançamentos e promoções</Fragment>,
            <Fragment><b>Aumente em até 11%</b> a rentabilidade dos pedidos emitidos</Fragment>,
            <Fragment>Configure a rentabilidade de cada produto e valorize os pedidos mais rentáveis</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png',
        }
    },
    aplicativoPotencializa: {
        title: 'Aplicativo que potencializa o representante na hora da venda',
        checklist: [
            <Fragment><b>Venda em qualquer lugar mesmo sem internet</b>: o sistema funciona offline</Fragment>,
            <Fragment><b>Sugestões de venda para o representante</b>: produtos para reposição, lançamentos e promoções</Fragment>,
            <Fragment><b>Histórico completo do cliente</b>, para não esquecer de nenhuma oportunidade</Fragment>,
            <Fragment><b>Aumento de 11% na rentabilidade das vendas</b></Fragment>,
            <Fragment><b>Imagem profissional</b>: catálogo digital com fotos de todos os produtos</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png',
        }
    },
    potencializaRepresentante: {
        title: 'Potencializa o representante na hora da venda',
        checklist: [
            <Fragment><b>Sugestões de venda</b>: produtos para reposição, lançamentos e promoções</Fragment>,
            <Fragment><b>Histórico completo do cliente</b>: para não esquecer de nenhuma oportunidade</Fragment>,
            <Fragment><b>Aumento de 11% na rentabilidade das vendas</b></Fragment>,
            <Fragment><b>Imagem profissional</b>: catálogo digital com fotos de todos os produtos</Fragment>,
            <Fragment>Configure a rentabilidade de cada produto e valorize os<b> pedidos mais rentáveis</b></Fragment>,

        ],
        img: {
            url: '/images/site/landing-pages/potencialize-vendas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/potencialize-vendas-mobile.png',
        }
    },
    vendaOnline: {
        title: <Fragment>Venda online para lojistas de todo o Brasil, 24h por dia</Fragment>,
        checklist: [
            <Fragment><b>Loja virtual exclusiva</b> para vender para seus clientes</Fragment>,
            <Fragment>Conquiste novos mercados</Fragment>,
            <Fragment>Esteja <b>disponível para vendas a qualquer hora</b>, quando o seu cliente quiser comprar</Fragment>,
            <Fragment>Aliado do vendedor e do televendas: ofereça um vendedor online para os seus representantes</Fragment>,
            <Fragment><b>Economize</b> em deslocamentos, passagens, hospedagens e alimentação</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png',
        }
    },
    vendaOnlineParceiros: {
        title: <Fragment>Venda online para lojistas de todo o Brasil, 24h por dia</Fragment>,
        checklist: [
            <Fragment>E-commerce B2B exclusivo para automatizar vendas de reposição para seus clientes</Fragment>,
            <Fragment>Aliado do representante e do televendas: ofereça um vendedor online para seu time comercial</Fragment>,
            <Fragment>Economize em deslocamentos, passagens, hospedagens e alimentação</Fragment>,
            <Fragment>Conquiste novos mercados</Fragment>,
            <Fragment>Esteja disponível para vendas a qualquer hora, quando o seu cliente quiser comprar</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png',
        }
    },
    receba24h: {
        title: <Fragment>Receba pedidos online <br />24h por dia</Fragment>,
        checklist: [
            <Fragment><b>Loja virtual exclusiva</b> para vender para seus clientes</Fragment>,
            <Fragment>Conquiste novos mercados</Fragment>,
            <Fragment>Esteja <b>disponível para vendas a qualquer hora</b>, quando o seu cliente quiser comprar</Fragment>,
            <Fragment>Aliado do vendedor e do televendas: ofereça um vendedor online para os seus representantes</Fragment>,
            <Fragment><b>Economize</b> em deslocamentos, passagens, hospedagens e alimentação</Fragment>,
        ],
        img: {
            url: '/images/site/landing-pages/receba-pedidos.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/receba-pedidos-mobile.png',
        }
    },
    gerencieVendedores: {
        title: <Fragment>Gerencie seus<br /> vendedores</Fragment>,
        checklist: [
            <Fragment>Agenda para controle e organização de visitas</Fragment>,
            <Fragment><b>Registro de atividades acessível para gestor e vendedor</b>: saiba exatamente o que aconteceu em cada visita</Fragment>,
            <Fragment>Garanta que os vendedores apliquem descontos e políticas comerciais corretamente</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/gerencie-vendedores.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/gerencie-vendedores-mobile.png',
        }
    },
    organizeUmSoLugar: {
        title: <Fragment>Organize tudo em um só lugar</Fragment>,
        checklist: [
            <Fragment><b>Elimine erros</b>: emita pedidos de forma prática, respeitando as tabelas de preços sem necessidade de redigitação.</Fragment>,
            <Fragment><b>Exporte pedidos em PDF</b>: com apenas um clique envie pedidos por e-mail ou WhatsApp.</Fragment>,
            <Fragment><b>Elimine as planilhas</b>: organize pedidos, clientes e tabelas de preços de todas as suas representadas em um único sistema.</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png',
        }
    },
    organizeUmSoLugarRep: {
        title: <Fragment>Organize tudo em um só lugar</Fragment>,
        checklist: [
            <Fragment><b>Elimine erros</b>: emita pedidos de forma prática, respeitando as tabelas de preços sem necessidade de redigitação.</Fragment>,
            <Fragment><b>Envie pedidos por Whatsapp</b>: com apenas um clique exporte pedidos em pdf e envie por e-mail ou whatsapp.</Fragment>,
            <Fragment><b>Elimine as planilhas</b>: organize pedidos, clientes e tabelas de preços de todas as suas representadas em um único sistema.</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/organize.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/organize.png',
        }
    },
    definaMetas: {
        title: <Fragment>Defina metas, acompanhe seu desempenho e suas comissões</Fragment>,
        checklist: [
            <Fragment><b>Acompanhe a evolução das suas vendas</b>: acesse relatórios em tempo real e controle os recebimentos por representada.</Fragment>,
            <Fragment><b>Gerencie sua equipe</b>: acompanhe os resultados do seu time e defina estratégias com base em dados.</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png',
        }
    },
    definaMetasRep: {
        title: <Fragment>Defina metas, acompanhe seu desempenho e suas comissões</Fragment>,
        checklist: [
            <Fragment><b>Acompanhe a evolução das suas vendas</b>: acesse relatórios em tempo real e controle os recebimentos por representada.</Fragment>,
            <Fragment><b>Gerencie sua equipe</b>: acompanhe os resultados do seu time e defina estratégias com base em dados.</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/metas.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/metas.png',
        }
    },
    monitoreClientes: {
        title: <Fragment>Monitore sua carteira de clientes</Fragment>,
        checklist: [
            <Fragment><b>Relatórios de Curva ABC</b>: tenha clareza dos clientes que trazem o maior ou menor retorno e defina estratégias personalizadas.</Fragment>,
            <Fragment><b>Mapa de carteira por região</b>: veja seu desempenho comercial em um mapa por estados e municípios.</Fragment>,
            <Fragment><b>Esteja sempre à frente</b>: obtenha insights valiosos sobre produtos e oportunidades de vendas.</Fragment>
        ],
        img: {
            url: '/images/site/landing-pages/representantes-comerciais/monitore.png',
            alt: 'Mercos, sistema de vendas, emissão de pedidos e e-commerce B2B',
            mobile: '/images/site/landing-pages/representantes-comerciais/monitore.png',
        }
    },
}
export default class TwoCols extends Component {
    constructor(props) {
        super(props)
        this.reverse = this.props.reverse;
        this.sectionData = SECTIONS[this.props.sectionName] || {};
        this.demoCTA = this.props.demoCTA;
    }

    render() {
        return (
            <Fragment>
                <section className={`two-col ${this.reverse ? 'reverse' : ''}`}>
           <div className="container">
                        <div className="column">
                                {this.props.imgBeforeTitle && 
                                    <Picture
                                        className='mobile-only'
                                        src={this.sectionData.img.mobile}
                                        alt={this.sectionData.title}
                                        mobileSrc={this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''}
                                    />
                                }
                                <h3 className='title'>{this.props.title ? this.props.title : this.sectionData.title}</h3>
                                {!this.props.imgBeforeTitle && 
                                    <Picture
                                        className='mobile-only'
                                        src={this.sectionData.img.mobile}
                                        alt={this.sectionData.title}
                                        mobileSrc={this.sectionData.img.mobile ? this.sectionData.img.mobile.url : ''}
                                    />
                                }
                            <CheckList>
                                {this.sectionData.checklist.map((item, index) => (
                                    <CheckListItem key={index}>
                                        <h4>{item}</h4>
                                    </CheckListItem>
                                ))}
                            </CheckList>
                            {this.demoCTA ? <DemoForm modalLink inlineBtns /> : ''}
                        </div>
                        <div className="column">
                            <Picture
                                className='desktop-only'
                                src={this.sectionData.img.url}
                                alt={this.sectionData.title}
                                mobileSrc=''
                            />
                        </div>
           </div>
                </section>
            </Fragment>
        )
    }
}

TwoCols.propTypes = {
    sectionName: PropTypes.oneOf(Object.keys(SECTIONS)).isRequired
};


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/LandingPageBlocks/TwoCols.jsx